type PasswordResetOptions = 0 | 1 | 2 | 3;

export const PasswordResetSteps = Object.freeze({
  REQUEST: 0,
  VERIFY: 1,
  RESET: 2,
  COMPLETED: 3,
} satisfies Record<string, PasswordResetOptions>);

export type PasswordResetStep = (typeof PasswordResetSteps)[keyof typeof PasswordResetSteps];
